import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";

import CloseIcon from "../Common/CloseIcon";

import { profileMobileMenu as menu } from "../../constants/menus";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  dialogPaper: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    maxHeight: "100%",
    backgroundColor: colors.black87,
    margin: 0,
    padding: "12px",
    borderRadius: 0,
  },
  menuItem: {
    color: colors.white,
    width: "130px",
    margin: "12px 0px",
  },
};

const ProfileMobileMenu = (props) => {
  const { classes, changeMenu } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <img src={images.menuMobileColored} alt="menu" />
      </Button>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column" alignItems="flex-end">
          <Grid
            item
            className="flexCenter"
            style={{ justifyContent: "flex-end", marginBottom: "40px" }}
          >
            <CloseIcon closeFunction={() => setOpen(false)} darkMode={true} />
          </Grid>
          {menu.map((item) => (
            <Grid
              item
              key={item}
              className={classes.menuItem}
              onClick={() => {
                setOpen(false);
                changeMenu(item);
              }}
            >
              {I18n.get(`profiles_${item}`)}
            </Grid>
          ))}
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(ProfileMobileMenu);
